import React from "react";
import Edit from "./Edit";
import Overview from "./Overview";
import { InfoProvider } from "../../context/InfoContext";

export const About = () => {
  return (
    <InfoProvider>
      <Overview />
    </InfoProvider>
  );
};

export const EditAbout = () => {
  return (
    <InfoProvider>
      <Edit />
    </InfoProvider>
  );
};
